import React, { useState } from "react";
import styles from "./index.module.scss";
import ConsultationHistory from "./ChildComponents/ConsultationHistory";
import HealthRecords from "./ChildComponents/HealthRecords/Index";
import { getKeysOfObject } from "../../Helpers/helperFunctions";
import RpmProfile from "../RpmModule/Components/PatientDetails/Components/RpmProfileold/RpmProfile";
import Profile from "./ChildComponents/Profile/Profile";
import AppointmentDetails from "./ChildComponents/AppointmentDetails/Index";
const PatientRpmDetailsView = () => {
  //Constants.................................................
  const navItems = {
    patientVitals: {
      name: "Appointment Details",
      key:"patientVitals",
      component: <AppointmentDetails/>,
    },
    consultationHistory: {
      name: "Consultation History",
      key:"consultationHistory",
      component: <ConsultationHistory />,
    },
    healthRecords: {
      name: "Personal Health Record",
      key:"healthRecords",
      component: <HealthRecords/>,
    },  
    profile: {
      name: "Profile",
      key:"profile",
      component: <Profile/>,
    },
  };

  //States....................................................
  const [activeTabItem, setActiveTabItem] = useState(
    navItems.patientVitals.key
  );


  //Functions.................................................


  const isTabActive = (navItem) => {
    return activeTabItem === navItem?.key;
  };
  const handleNavItemClick = (navItem) => {
    setActiveTabItem(navItem?.key);
  };

  return (
    <div className={styles.container}>
      <div className={styles.patientRpmNav}>
        <ul>
          {getKeysOfObject(navItems).map((navItemName, key) => {
            return (
              <>
                <li
                  key={key}
                  className={
                    isTabActive(navItems[navItemName]) &&
                    styles.patientRpmNavActive
                  }
                  onClick={() => {
                    handleNavItemClick(navItems[navItemName]);
                  }}
                >
                  <div>{navItems[navItemName]?.name}</div>
                </li>

                {key < getKeysOfObject(navItems).length - 1 ? " | " : null}
              </>
            );
          })}
        </ul>
      </div>

      {navItems[activeTabItem]?.component}
    </div>
  );
};

export default PatientRpmDetailsView;
